export default __webpack_public_path__ + "static/media/bootstrap.d87c3aa1.png";